export default function OptInPolicy() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900" data-testid="opt-in-policy-page">
      {/* Header */}
      <header className="bg-slate-950 text-white py-6 px-4 sm:px-8 border-b-4 border-cyan-500">
        <div className="max-w-3xl mx-auto flex items-center gap-3">
          <div className="h-10 w-10 rounded-lg bg-gradient-to-br from-cyan-400 to-cyan-700 flex items-center justify-center shadow-lg shadow-cyan-500/40">
            <span className="text-white text-lg" aria-hidden="true">📡</span>
          </div>
          <div>
            <div className="text-[11px] font-black uppercase tracking-[0.22em] text-white">
              Field<span className="text-cyan-400">Radar</span>
            </div>
            <div className="text-[10px] text-slate-400 uppercase tracking-widest">Property Maintenance Platform</div>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-8 py-10">
        <h1 className="text-3xl sm:text-4xl font-black tracking-tight mb-2">SMS Opt-In & Consent Policy</h1>
        <p className="text-sm text-slate-500 mb-8">
          Effective: Feb 29, 2026 &middot; Field Radar &middot; operated by GoPMR
        </p>

        <section className="space-y-6 text-[15px] leading-relaxed">
          <div>
            <h2 className="text-xl font-black text-slate-900 mb-2">1. Who receives our SMS</h2>
            <p>
              Field Radar sends automated SMS messages exclusively to <strong>field technicians</strong>
              (plumbers, HVAC contractors, electricians, cleaners, and other maintenance vendors)
              who have been individually onboarded by an authorized property manager operating
              the Field Radar platform. We do <strong>not</strong> send marketing or promotional
              messages, and we do <strong>not</strong> message residents, tenants, or the general public
              through this channel.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-black text-slate-900 mb-2">2. Types of messages we send</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>Confirmations when a tech's photo has been auto-attached to a work order (e.g. &quot;✅ Photo attached to WO #12345 at 5346 Chew Ave.&quot;)</li>
              <li>Disambiguation prompts when a photo could match more than one open work order (e.g. &quot;🤔 Which WO? Reply 1, 2, or 3.&quot;)</li>
              <li>Occasional operational reminders (e.g. &quot;Please send a photo of the finished job.&quot;)</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-black text-slate-900 mb-2">3. Message frequency</h2>
            <p>
              Frequency depends on the volume of work orders assigned to each technician.
              Typical technicians receive between <strong>5 and 30 messages per week</strong>.
              Messages are transactional in nature and are triggered only by the technician's
              own actions (e.g. sending a photo).
            </p>
          </div>

          <div>
            <h2 className="text-xl font-black text-slate-900 mb-2">4. How consent is captured</h2>
            <p>
              Consent is captured <strong>in person or during a dispatch phone call</strong> between
              the property manager and the technician, at the time the technician is onboarded to
              the Field Radar platform. Consent is documented by the property manager adding the
              technician's mobile number to an internal &quot;Field-Guy Whitelist&quot; inside the
              Field Radar admin console. No SMS is ever sent to a number that is not on this
              whitelist. Numbers can only be added by an authenticated admin user of the platform.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-black text-slate-900 mb-2">5. Opting out (STOP)</h2>
            <p>
              Technicians may opt out at any time by replying <strong>STOP</strong>, <strong>UNSUBSCRIBE</strong>,
              <strong> CANCEL</strong>, <strong>END</strong>, or <strong>QUIT</strong> to any message received
              from Field Radar. Their number will be immediately removed from our whitelist and no
              further messages will be sent. Replying <strong>HELP</strong> returns contact information
              and a link back to this policy.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-black text-slate-900 mb-2">6. Message and data rates</h2>
            <p>
              Message and data rates may apply. Field Radar does not charge technicians for SMS;
              standard rates from the technician&apos;s mobile carrier apply.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-black text-slate-900 mb-2">7. Privacy</h2>
            <p>
              We collect and store technician mobile numbers, photo attachments, and message
              metadata solely for the purpose of routing work-order photos to the correct
              property-management record. This information is <strong>not sold, rented, or shared
              with third parties for marketing purposes</strong>. Aggregated, non-personally-identifiable
              usage data may be used internally to improve the product.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-black text-slate-900 mb-2">8. Contact</h2>
            <p>
              For questions, opt-out issues, or policy concerns, contact us at{" "}
              <a href="mailto:support@fieldradar.pro" className="text-cyan-700 underline font-bold">
                support@fieldradar.pro
              </a>.
            </p>
          </div>
        </section>

        <footer className="mt-12 pt-6 border-t border-slate-200 text-xs text-slate-500 text-center">
          &copy; 2026 Field Radar &middot; Operated by GoPMR &middot; Philadelphia, PA
        </footer>
      </main>
    </div>
  );
}
